<img 
  [src]="displayImageUrl" 
  [alt]="alt" 
  [width]="width"
  [height]="height"
  [class]="cssClass"
  style="border-radius: 50%; object-fit: cover;" /> 